
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationGuard } from './routing/guards/authentication/authentication.guard';
import { AuthorizationGuard } from './routing/guards/authorization/authorization.guard';
import { Sandbox } from './sandbox/sandbox';
import { Sandbox as SandboxSymbol } from 'src/app';;
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { ConfigService } from 'src/shared/services/config.service';


 function configureRecaptchaSiteKey(configService: ConfigService) {
  const siteKey =  configService.appSettings.siteKey;
  return siteKey;
}

@NgModule({
  imports: [
    CommonModule,
    RecaptchaV3Module
  ],
  providers: [
    AuthenticationGuard,
    AuthorizationGuard,
    { provide: SandboxSymbol, useClass: Sandbox },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory:  configureRecaptchaSiteKey,
      deps: [ConfigService],
      multi: false
    },
  ],
  declarations: [],
  exports: [
  ]
})
export class AppModule { 
 
}
